import React from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose, DialogDescription } from "./dialog";
import { cn } from "../../libs/utils";

const sizeClass = {
  sm: "sm:max-w-sm",
  md: "sm:max-w-md",
  lg: "sm:max-w-2xl",
  xl: "sm:max-w-4xl",
};

/**
 * Thin, generic modal wrapper around the existing Dialog primitives
 * (Radix-based, already used by ConfirmDialog). Any new feature needing a
 * modal — not just Batch — can reuse this instead of hand-rolling Dialog
 * boilerplate again.
 */
const Modal = ({ open, onClose, title, description, size = "md", children }) => (
  <Dialog open={open} onOpenChange={(next) => !next && onClose?.()}>
    <DialogContent className={cn("max-w-md", sizeClass[size])} {...(!description ? { "aria-describedby": undefined } : {})}>
      <DialogHeader>
        <div className="flex items-start justify-between gap-4">
          <div>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </div>
          <DialogClose>
            <button
              type="button"
              aria-label="Close"
              className="rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
            >
              <X className="h-4 w-4" />
            </button>
          </DialogClose>
        </div>
      </DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
);

export default Modal;
